import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Close from 'src/assets/images/CloseProduct.svg';
import { checkImpersonationActive } from 'src/utils/util';
import ImpersonateDisabled from 'src/assets/images/Impersonate_disable.png';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import {
    CloseIcon,
    Container,
    Container1,
    Container2,
    ContainerGrid1,
    ContainerGrid1Desktop,
    ContainerGrid1Mobile,
    ContainerGrid1Mob,
    Name,
    Id,
    IdMob,
    LineDesktop,
    SapIdDesktop,
    HeaderTextContainer2,
    HeaderTextContainer3,
    IconContainer,
    StyledImage,
    ButtonLabel,
    IPadPotrait,
    ImpersonateIconContainer,
    UserProxiesContainer,
    ImpersonateContainer,
    PopupContainer,
    LineMob,
    SapIdMob,
    ButtonLabel1,
} from './index.styled';
import ProxyTab1 from '../proxyTab1';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import ArrowDecision from 'src/assets/images/MDI - arrow-decision-outline.svg';
import Impersonate from 'src/assets/images/Impersonate.svg';
import {
    NameTabs,
    NameTabsBasedOnRole,
} from 'src/pages/admin/nameDetailsTabs/adminNameTabConstants';
import AssociatedPhysician from 'src/pages/admin/nameDetails/associatedPhysicianCard';
import AssociatedAccount from 'src/pages/admin/nameDetails/associatedAccountCard';
import AdminNameDetailTabListContainer from '../nameDetailsTabs/adminNameDetailTabListContainer';
import ImpersonateProxy from '../impersonateProxy';
import SalesStructureAssignment from './ssa';
import {
    setshowProxy,
    setProxyTabData,
    setAccountTabActiveId,
} from 'src/pages/admin/redux/action';
import { getUser } from 'src/pages/equity/components/common/utils/eventHandlerUtil';
import {
    CS_USER_ROLE,
    FIA_USER_ROLE,
    FIM_USER_ROLE,
    PROXY,
    SR_USER_ROLE,
} from 'src/constants/appConstants';
import { useTranslation } from 'react-i18next';
import { getConfigurations } from 'src/common/redux/actions';
const NameDetails = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [userDetaisTab, setUserDetailsTab] = useState('Tab1');

    const onTabSwitchHandler = (Id) => {
        setUserDetailsTab(Id);
    };
    const userRoleChange = useSelector(
        (state) => state.AdminReducer.userRoleChange
    );
    const { physicians, accounts, proxies } = useSelector(
        (state) => state.loginReducer.moreVisibility
    );
    const showProxy = useSelector((state) => state.AdminReducer.showProxy);

    // const [proxyTabData, setProxyTabData] = useState({});
    // const [showProxy, setshowProxy] = useState(false);
    const [proxy] = useState(false);

    const openProxy = (proxyTabData) => {
        dispatch(getConfigurations({ resourceType: 'visibility', module: PROXY}, PROXY));
        dispatch(setProxyTabData(proxyTabData));
        dispatch(setshowProxy(true));
    };

    const closeProxy = (fromBackButton) => {
        dispatch(setAccountTabActiveId('proxiesTab1'));
        dispatch(setProxyTabData({}));
        if (fromBackButton === true) {
            dispatch(setProxyTabData({}));
            dispatch(setshowProxy(false));
        } else {
            props.setshowNameDetails(false);
        }
    };

    const [impersonateProxyData, setImpersonateProxyData] = useState({});
    const [showImpersonateProxy, setshowImpersonateProxy] = useState(false);
    const [impersonateProxy] = useState(false);

    const openImpersonateProxy = (impersonateProxyData) => {
        if (
            !checkImpersonationActive() &&
            !checkUserRestriction(impersonateProxyData.userRoles[0])
        ) {
            setImpersonateProxyData(impersonateProxyData);
            setshowImpersonateProxy(true);
            sessionStorage.setItem('adminImpersonation', true);
        }
    };

    const closeImpersonateProxy = () => {
        setImpersonateProxyData({});
        // sessionStorage.removeItem('adminImpersonation');
        // sessionStorage.removeItem('SelectedUserData');
        setshowImpersonateProxy(false);
    };
    const assignmentCheck = [
        'MDT Spine CSR',
        'MDT Spine CC',
        'MDT Spine FIM',
        'MDT Spine ITA',

        'MDT Spine SP',
    ]; 
    const checkUserRestriction = (role) => {
        return (
            getUser() == FIM_USER_ROLE &&
            ![SR_USER_ROLE, CS_USER_ROLE, FIA_USER_ROLE].includes(role)
        );
    };
    return (
        <>
            <Container1 container direction="row">
                <ContainerGrid1Desktop item xs={11} sm={6} md={2} lg={2} xl={2}>
                    {props.NameDetails.firstName && (
                        <Name className="admin-person-name-dt-mask">
                            {props?.NameDetails?.firstName +
                                ' ' +
                                (props?.NameDetails?.lastName
                                    ? props?.NameDetails?.lastName
                                    : '')}
                        </Name>
                    )}
                    <IPadPotrait>
                        <Id>{props.NameDetails.networkIdName}</Id>
                        {props.NameDetails.sapId && (
                            <>
                                <LineDesktop>|</LineDesktop>
                                <SapIdDesktop>
                                    {t('admin.adminList.sapId')}{' '}
                                    <span className="admin-person-name-dt-mask">{accountNumberZeroTrimmer(
                                        props.NameDetails.sapId
                                    )}</span>
                                </SapIdDesktop>
                            </>
                        )}
                    </IPadPotrait>
                </ContainerGrid1Desktop>
                <Container2 mbWidth={'97%'}>
                    <ContainerGrid1Mobile
                        item
                        xs={8}
                        sm={2}
                        md={2}
                        lg={2}
                        xl={2}
                        mobile={8}
                    >
                        {props?.NameDetails?.firstName && (
                            <Name className="admin-person-name-dt-mask">
                                {props?.NameDetails?.firstName +
                                    ' ' +
                                    (props?.NameDetails?.lastName
                                        ? props?.NameDetails?.lastName
                                        : '')}
                            </Name>
                        )}
                    </ContainerGrid1Mobile>

                    <ContainerGrid1Mobile
                        item
                        xs={4}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        mobile={4}
                    >
                        {/* <CloseIcon
                            mobilePath={Close}
                            onClick={props.handleClose}
                            show={true}
                        /> */}
                    </ContainerGrid1Mobile>
                </Container2>
                <ContainerGrid1Mob
                    item
                    xs={11}
                    sm={3}
                    md={3}
                    lg={3}
                    xl={3}
                    mobile={12}
                >
                    <IdMob>
                        {props?.NameDetails?.networkIdName}
                        {props?.NameDetails?.sapId && (
                            <>
                                {' '}
                                <LineMob>|</LineMob>{' '}
                                <SapIdMob>
                                    {t('admin.adminList.sapId')}{' '}
                                    <span className="admin-person-name-dt-mask">{accountNumberZeroTrimmer(
                                        props.NameDetails.sapId
                                    )}</span>
                                </SapIdMob>
                            </>
                        )}
                    </IdMob>
                </ContainerGrid1Mob>
                <ContainerGrid1
                    item
                    xs={11}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                    mobile={6}
                    className={'sapIdAndNetID'}
                >
                    <Id>{props.NameDetails.networkIdName}</Id>
                    {props.NameDetails.sapId && (
                        <>
                            <LineDesktop>|</LineDesktop>
                            <SapIdDesktop>
                                {t('admin.adminList.sapId')}{' '}
                                <span className="admin-person-name-dt-mask">{accountNumberZeroTrimmer(
                                    props.NameDetails.sapId
                                )}</span>
                            </SapIdDesktop>
                        </>
                    )}
                </ContainerGrid1>
                <IconContainer
                    item
                    xs={12}
                    sm={5}
                    md={5}
                    lg={5}
                    xl={5}
                    mobile={6}
                >
                    {proxies &&
                    !assignmentCheck.includes(userRoleChange) &&
                    props.NameDetails &&
                    props.NameDetails.userRoles[0] !== 'Un-assigned' ? (
                        <UserProxiesContainer mbWidth={'172px'}>
                            <ImpersonateContainer>
                                <a
                                    id="admin-nameDetails-userProxiesButton"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}
                                    onClick={() => openProxy(props.NameDetails)}
                                >
                                    <StyledImage
                                        src={ArrowDecision}
                                        width="auto"
                                        height="auto"
                                    />
                                    <ButtonLabel>
                                        {t('admin.nameDetails.userProxies')}
                                    </ButtonLabel>
                                </a>
                            </ImpersonateContainer>
                        </UserProxiesContainer>
                    ) : (
                        <div style={{ width: '170px' }}></div>
                    )}

                    {props.NameDetails &&
                    props.NameDetails.userRoles[0] !== 'Un-assigned' ? (
                        <ImpersonateIconContainer
                            mbWidth={'170px'}
                            boxShadow={
                                checkImpersonationActive() ||
                                checkUserRestriction(
                                    props.NameDetails.userRoles[0]
                                )
                                    ? '0px 0px 2px #9f9f9f'
                                    : '0px 0px 2px #00000029'
                            }
                            border={
                                checkImpersonationActive() ||
                                checkUserRestriction(
                                    props.NameDetails.userRoles[0]
                                )
                                    ? '1px solid #9f9f9f'
                                    : '1px solid #1010eb'
                            }
                        >
                            <ImpersonateContainer
                                labelColor={
                                    checkImpersonationActive() ||
                                    checkUserRestriction(
                                        props.NameDetails.userRoles[0]
                                    )
                                        ? '#9f9f9f'
                                        : '#1010eb'
                                }
                            >
                                <a
                                    id="admin-nameDetails-impersonateButton"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}
                                    onClick={() =>
                                        openImpersonateProxy(props.NameDetails)
                                    }
                                >
                                    <StyledImage
                                        src={
                                            checkImpersonationActive() ||
                                            checkUserRestriction(
                                                props.NameDetails.userRoles[0]
                                            )
                                                ? ImpersonateDisabled
                                                : Impersonate
                                        }
                                        width="auto"
                                        height="auto"
                                    />
                                    <ButtonLabel1
                                        labelColor={
                                            checkImpersonationActive() ||
                                            checkUserRestriction(
                                                props.NameDetails.userRoles[0]
                                            )
                                                ? '#9f9f9f'
                                                : '#1010eb'
                                        }
                                    >
                                        {t('admin.adminList.impersonate')}
                                    </ButtonLabel1>
                                </a>
                            </ImpersonateContainer>
                        </ImpersonateIconContainer>
                    ) : null}
                </IconContainer>
                <ContainerGrid1Desktop
                    item
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    className="close-icon"
                >
                    {/* <CloseIcon
                        mobilePath={Close}
                        onClick={props.handleClose}
                        show={true}
                    /> */}
                </ContainerGrid1Desktop>
            </Container1>
            <Container>
                <AdminNameDetailTabListContainer
                    accountDetailTabList={
                        assignmentCheck.includes(userRoleChange)
                            ? NameTabsBasedOnRole()
                            : Object.prototype.hasOwnProperty.call(
                                  props.NameDetails,
                                  'salesHirerachy'
                              )
                            ? NameTabs().filter((tab) =>
                                  tab.id === 'Tab2'
                                      ? physicians
                                      : tab.id === 'Tab3'
                                      ? accounts
                                      : true
                              )
                            : NameTabsBasedOnRole()
                    }
                    tabActiveId={userDetaisTab}
                    tabSwitch={onTabSwitchHandler}
                />
            </Container>
            <HeaderTextContainer2
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                mobile={6}
                key="role"
            >
                {userDetaisTab === 'Tab1' && (
                    <SalesStructureAssignment
                        salesHirerachy={props.NameDetails.salesHirerachy}
                        userData={props.NameDetails}
                        handleClose={props.handleClose}
                    />
                )}
            </HeaderTextContainer2>

            <HeaderTextContainer3
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                mobile={6}
                key="role"
            >
                {userDetaisTab === 'Tab2' && (
                    <AssociatedPhysician 
                        userData={props.NameDetails}
                        employeeRole={getUser()}
                    />
                )}
            </HeaderTextContainer3>

            <HeaderTextContainer3
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                mobile={6}
                key="role"
            >
                {userDetaisTab === 'Tab3' && (
                    <AssociatedAccount 
                        userData={props.NameDetails}
                        employeeRole={getUser()}
                    />
                )}
            </HeaderTextContainer3>

            {showProxy && (
                <ModalDialog
                    modalHeight={'calc(100vh - 130px)'}
                    maxWidth={'841px'}
                    marginTop={'7.5rem'}
                    padding={'0'}
                    // isIPadPotrait={true}
                    top={'8%'}
                    zIndex={'2000'}
                    handleClose={() => closeProxy()}
                >
                    <PopupContainer>
                        <ProxyTab1
                            addProxyPopup={proxy}
                            handleClose={closeProxy}
                            isFromAccount={props.isFromAccount}
                            // proxyTabData={proxyTabData}
                        />
                    </PopupContainer>
                </ModalDialog>
            )}

            {showImpersonateProxy && (
                <ImpersonateProxy
                    addProxyPopup={impersonateProxy}
                    handleClose={closeImpersonateProxy}
                    isFromAccount={props.isFromAccount}
                    impersonateProxyData={impersonateProxyData}
                    setshowImpersonateProxy={setshowImpersonateProxy}
                    isNameDetails={true}
                    setshowNameDetails={props.setshowNameDetails}
                    setClearFilterClicked={props.setClearFilterClicked}
                />
            )}
        </>
    );
};

export default NameDetails;
